import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HttpRequest {
  constructor(private http: HttpClient) { }

  // get<T>(url: string, params?: HttpParams | { [param: string]: string | string[] }, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<T> {
  //   return this.http.get<T>(url, { params, headers });
  // }

  get<T>(
    url: string,
    options?: {
      params?: HttpParams | Record<string, string | string[]>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    return this.http.get(url, options as any);
  }
  getParam<T>(
    url: string,
    options?: {
      params?: HttpParams | Record<string, string | string[] | number | boolean>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    return this.http.get(url, options as any);
  }

  post<T>(
    url: string,
    body: any,
    options?: {
      params?: HttpParams | Record<string, string | string[]>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    return this.http.post(url, body, options as any);
  }
  postPDF<T>(
    url: string,
    body: any,
    options?: {
      params?: HttpParams | Record<string, string | string[]>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    return this.http.post(url, body, options as any);
  }
  postParam<T>(
    url: string,
    body: any,
    options?: {
      params?: HttpParams | Record<string, string | string[] | number>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    // const fullUrl = this.buildUrl(url);
    return this.http.post(url, body, options as any);
  }

  // post<T>(url: string, body: any, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<T> {
  //   const fullUrl = this.buildUrl(url);
  //   return this.http.post<T>(fullUrl, body, { headers });
  // }

  // put<T>(url: string, body: any, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<T> {
  //   const fullUrl = this.buildUrl(url);
  //   return this.http.put<T>(fullUrl, body, { headers });
  // }

  put<T>(
    url: string,
    body: any,
    options?: {
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    // const fullUrl = this.buildUrl(url);
    return this.http.put<T>(url, body, options as any);
  }
  putParam<T>(
    url: string,
    body: any,
    options?: {
      params?: HttpParams | Record<string, string | string[] | any>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    // const fullUrl = this.buildUrl(url);
    return this.http.put<T>(url, body, options as any);
  }

  delete<T>(url: string, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<T> {
    // const fullUrl = this.buildUrl(url);
    return this.http.delete<T>(url, { headers });
  }

  patch<T>(url: string, body: any, headers?: HttpHeaders | { [header: string]: string | string[] }): Observable<T> {
    // const fullUrl = this.buildUrl(url);
    return this.http.patch<T>(url, body, { headers });
  }
  patchParam<T>(
    url: string,
    body: any,
    options?: {
      params?: HttpParams | Record<string, string | string[] | any>;
      headers?: HttpHeaders | Record<string, string | string[]>;
      responseType?: 'json' | 'blob' | 'text';
      observe?: 'body' | 'response';
    }
  ): Observable<any> {
    // const fullUrl = this.buildUrl(url);
    return this.http.patch<T>(url, body, options as any);
  }
}

